import { createModel } from "@byted/hooks";
const useGeneralConfig = (initialState) => {
  var _a, _b, _c, _d, _e;
  return {
    userLang: (_a = initialState == null ? void 0 : initialState.userLang) != null ? _a : "en",
    uid: (_b = initialState == null ? void 0 : initialState.uid) != null ? _b : "",
    userCountry: (_c = initialState == null ? void 0 : initialState.userCountry) != null ? _c : "",
    appId: (_d = initialState == null ? void 0 : initialState.appId) != null ? _d : -1,
    skipExperimentAuthorisation: (_e = initialState == null ? void 0 : initialState.skipExperimentAuthorisation) != null ? _e : false,
    btm: initialState == null ? void 0 : initialState.btm,
    teaCollectEvent: void 0,
    teaCallbackOn: void 0,
    teaCallbackOff: void 0,
    teaSessionId: void 0
  };
};
const SessionReplayGeneralConfigModel = createModel(useGeneralConfig);
var useGeneralConfigs_default = SessionReplayGeneralConfigModel.useContext;
export {
  SessionReplayGeneralConfigModel,
  useGeneralConfigs_default as default,
  useGeneralConfig
};
